export default (theme) => ({
    container: {
        marginTop: '90px',
    },

    tituloPrincipal: {
        fontWeight: '500',
        fontSize: '26px',
        lineHeight: '43px',
        color: '#02599E',
    },

    titulo: {
        fontWeight: '400',
        fontSize: '20px',
        lineHeight: '43px',
        color: '#02599E',
    },

    containerBtn: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '30px',
        marginBottom: '30px',
    },

    btnNuevaPresentacion: {
        marginLeft: '16px',
    },

    btnExportar: {
        width: '200px',
    },

    iconoExcel: {
        width: '12px',
        marginRight: '10px',
    },
});
